import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

Vue.config.productionTip = false;

firebase.initializeApp({
  apiKey: "AIzaSyArXfRuF8_HGuwYTmhnD5O_u6uLl3f7yig",
  authDomain: "town-faker.firebaseapp.com",
  databaseURL: "https://town-faker.firebaseio.com",
  projectId: "town-faker",
  storageBucket: "town-faker.appspot.com",
  messagingSenderId: "891849184843",
  appId: "1:891849184843:web:9275b5fd853ef75b301fce",
  measurementId: "G-QKEM2RHGB6"
})
firebase.analytics();

export const db = firebase.firestore()

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
